import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Mixpanel from './mixpanelConfig';

export function MixpanelProvider({ children }) {
  const location = useLocation();
  
  // Track page views whenever the location changes
  useEffect(() => {
    if (location) {
      const url = location.search 
        ? `${location.pathname}${location.search}`
        : location.pathname;
        
      Mixpanel.trackPageView(url);
    }
  }, [location]);
  
  return children;
}

export default MixpanelProvider;